import { render } from "./FooterContent.vue?vue&type=template&id=3024981a&scoped=true"
const script = {}

import "./FooterContent.vue?vue&type=style&index=0&id=3024981a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3024981a"]])

export default __exports__